import React from 'react'
import styled, {css} from 'styled-components'

const Group = styled.div<{inline?: boolean; readOnly?: boolean}>`
  ${p => p.inline && `display: inline-flex;`}
  > label,
  > button,
  > div {
    border-radius: 0;
    ${p =>
      p.inline
        ? css`
            &:first-child:not(:only-child) {
              border-radius: ${p.theme.borderRadius} 0 0 ${p.theme.borderRadius};
            }
            &:last-child:not(:only-child) {
              border-radius: 0 ${p.theme.borderRadius} ${p.theme.borderRadius} 0;
            }
            &:not(:last-child) {
              /* Read-only fields are bordered, so overlap them by 1px to form a
                 single hairline divider instead of a gap. */
              margin-right: ${p.readOnly ? '-1px' : '1px'};
            }
            &:only-child {
              border-radius: ${p.theme.borderRadius};
            }
          `
        : css`
            &:first-child {
              border-radius: ${p.theme.borderRadius} ${p.theme.borderRadius} 0 0;
            }

            &:last-child {
              border-radius: 0 0 ${p.theme.borderRadius} ${p.theme.borderRadius};
            }
            &:not(:last-child) {
              margin-bottom: ${p.readOnly ? '-1px' : '1px'};
            }
            &:only-child {
              border-radius: ${p.theme.borderRadius};
            }
          `}
  }
`
interface InputGroupProps {
  children: React.ReactNode
  style?: React.CSSProperties
  inline?: boolean
  readOnly?: boolean
}

export const InputGroup = ({
  children,
  style,
  inline,
  readOnly
}: InputGroupProps) => {
  return (
    <Group inline={inline} readOnly={readOnly} style={style}>
      {children}
    </Group>
  )
}
